import React from 'react'

import ErrorMessage from '../items/ErrorMessage'
import AnimationModal from './AnimationModal'

/**
 * エラーモーダル
 */
const ErrorModal: React.FC<ErrorModalProps> = (props) => {
  return (
    <AnimationModal on={props.on} type="top" animationType="slide">
      <ErrorMessage transparent message={props.message} marginNone />
    </AnimationModal>
  )
}

type ErrorModalProps = {
  on: boolean
  message: string
}

export default React.memo<ErrorModalProps>(ErrorModal)
